import { ensureArray, requireField } from './validators';

export default class AttendanceRecord {
  constructor(data = {}) {
    requireField(data.rate, 'attendance.rate');

    this.scheduled = data.scheduled || [];
    this.rate = data.rate;
    this.trend = data.trend || 'stable';
    this.last8Weeks = data.last8Weeks || [];
    ensureArray(this.last8Weeks, 'attendance.last8Weeks');
    this.absenceReasons = data.absenceReasons || [];
    this.logs = data.logs || [];
  }

  toJSON() {
    return { ...this };
  }
}
